import axios from "axios";
import ENV from "../../config";
export default class VersionCheckHelper {
  static startPollingForVersion() {
    this.fetchLatestVersion(`${ENV.SPEED_URL}/static/version.json`);
    setInterval(() => {
      this.fetchLatestVersion(`${ENV.SPEED_URL}/static/version.json`);
    }, 30000);
  }

  static fetchLatestVersion(url: string) {
    // add timestamp to prevent caching
    axios.get(url + "?t=" + new Date().getTime()).then(response => {
      response.data &&
        response.data.hash &&
        this.hasHashChanged(response.data.hash);
    });
  }

  static hasHashChanged(latestHash: string) {
    if (ENV.BUILD_HASH !== latestHash) {
      console.log("BUILD HASH CHANGED");
      window.location.reload();
    }
  }
}
